import { action } from 'satcheljs';

export const showPivotEnableDisableDialog = action('SHOW_PIVOT_REORDER_DIALOG');
